import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { LandingPageComponent } from "./LandingPageComponent/LandingPageComponent";

export function CelenoraComponent() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPageComponent />}></Route>
        <Route path="*" element={<Navigate to="/" replace />}></Route>
      </Routes>
    </BrowserRouter>
  );
}
